/* eslint-disable */
// import {tokenAlive} from "@/Shared/jwtHelper";
import axios from 'axios'
const state = () => ({
    roleprivilegesdata: "",
});
const getters = {
      getRolesprivilegeData(state: { roleprivilegesdata: any }){
        return state.roleprivilegesdata;
      },
};

const actions = {
     async setrolesprivileges({commit}: any, data: any) {
      // localStorage.setItem("roleprivilegedata", 'test test,');
            commit("setroleprivileges", data+',test');
                    },
    async loadRolePrivileges({commit}: any, data: any) {
      const idToken = data.idtoken;
      const roleGuid = data.roledata;

      if (!idToken || !roleGuid) {
        // no role selected → clear out any stale data
        commit('clearRolePrivileges')
        return
      }

      try {
        
        const res = await axios.get(
          `${process.env.VUE_APP_Service_URL}/account-core/roles/getscreenroleprivilegebyid`,
          {
            params: { guid: roleGuid },
            headers: {
              Authorization: `Bearer ${idToken}`,
              'Content-Type': 'application/json',
            },
          }
        )

        if (res.data !== 'No ScreenRolePrivilege found') {
          const data = res.data.screens
          let privilegevalues: string[] = []
        await (data).forEach((screen) => {
          for (let j = 0; j < screen.controls.length; j++) {
            if (!privilegevalues.includes(screen.name + " " + screen.controls[j])) {
              privilegevalues.push(screen.name + " " + screen.controls[j]);
            }
          }
        });
      
      let userprivilegestring = privilegevalues.join();
         
          commit('setroleprivileges', `test test,${userprivilegestring}`);
        } else {
          commit('clearRolePrivileges')
        }
      } catch (err) {
        console.error('Error loading role privileges:', err)
        commit('clearRolePrivileges')
      }
    },
};

const mutations = {
    setroleprivileges(state: { roleprivilegesdata: any }, userroleprivilege: any){
      
          if(userroleprivilege){
        state.roleprivilegesdata = userroleprivilege;
       
        // localStorage.setItem("roleprivilegedata",userroleprivilege +',test');
          }
          else{
            state.roleprivilegesdata = 'test test,';
          }
      },
       clearRolePrivileges(state) {
      state.roleprivilegesdata = null
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}
